import { render, staticRenderFns } from "./onlineTrainingHome.vue?vue&type=template&id=5cf51a1d&scoped=true&"
import script from "./onlineTrainingHome.vue?vue&type=script&lang=js&"
export * from "./onlineTrainingHome.vue?vue&type=script&lang=js&"
import style0 from "./onlineTrainingHome.vue?vue&type=style&index=0&id=5cf51a1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf51a1d",
  null
  
)

export default component.exports